export default "__VITE_ASSET__Bmc7Ohd1__"